/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface RevenueWidgetData
 */
export interface RevenueWidgetData {
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    totalRefunds: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    totalPayments: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    totalCredits: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    totalDebits: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    openBalance: number;
    /**
     * 
     * @type {Date}
     * @memberof RevenueWidgetData
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevenueWidgetData
     */
    periodEnd: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof RevenueWidgetData
     */
    membersWithOpenBalance: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    classRevenue: number;
    /**
     * 
     * @type {number}
     * @memberof RevenueWidgetData
     */
    ticketRevenue: number;
}

/**
 * Check if a given object implements the RevenueWidgetData interface.
 */
export function instanceOfRevenueWidgetData(value: object): value is RevenueWidgetData {
    if (!('totalRefunds' in value) || value['totalRefunds'] === undefined) return false;
    if (!('totalPayments' in value) || value['totalPayments'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('totalCredits' in value) || value['totalCredits'] === undefined) return false;
    if (!('totalDebits' in value) || value['totalDebits'] === undefined) return false;
    if (!('openBalance' in value) || value['openBalance'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('membersWithOpenBalance' in value) || value['membersWithOpenBalance'] === undefined) return false;
    if (!('classRevenue' in value) || value['classRevenue'] === undefined) return false;
    if (!('ticketRevenue' in value) || value['ticketRevenue'] === undefined) return false;
    return true;
}

export function RevenueWidgetDataFromJSON(json: any): RevenueWidgetData {
    return RevenueWidgetDataFromJSONTyped(json, false);
}

export function RevenueWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevenueWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRefunds': json['totalRefunds'],
        'totalPayments': json['totalPayments'],
        'revenue': json['revenue'],
        'totalCredits': json['totalCredits'],
        'totalDebits': json['totalDebits'],
        'openBalance': json['openBalance'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'membersWithOpenBalance': ApiUserTasksGetPageParameterFromJSON(json['membersWithOpenBalance']),
        'classRevenue': json['classRevenue'],
        'ticketRevenue': json['ticketRevenue'],
    };
}

export function RevenueWidgetDataToJSON(json: any): RevenueWidgetData {
    return RevenueWidgetDataToJSONTyped(json, false);
}

export function RevenueWidgetDataToJSONTyped(value?: RevenueWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRefunds': value['totalRefunds'],
        'totalPayments': value['totalPayments'],
        'revenue': value['revenue'],
        'totalCredits': value['totalCredits'],
        'totalDebits': value['totalDebits'],
        'openBalance': value['openBalance'],
        'periodStart': value['periodStart'].toISOString().substring(0,10),
        'periodEnd': value['periodEnd'].toISOString().substring(0,10),
        'membersWithOpenBalance': ApiUserTasksGetPageParameterToJSON(value['membersWithOpenBalance']),
        'classRevenue': value['classRevenue'],
        'ticketRevenue': value['ticketRevenue'],
    };
}

